import { useTranslation } from "react-i18next";
import { Title } from "components";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import DateSpan from "../date-span/DateSpan";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";

const ObservationActionPerformed = ({ viewMode, isFullWidth }) => {
  const { t } = useTranslation();
  const status = ACTION_STATUS.performed;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Performed")} />
        <DateSpan viewMode={viewMode} status={status} />
        <ActionModalDescriptionSection
          task="observation"
          isViewMode={isViewMode}
        />
      </div>
    </div>
  );
};

export default ObservationActionPerformed;
